import { Icon } from 'idea-react';
import { observer } from 'mobx-react';
import { Component } from 'react';
import { Button } from 'react-bootstrap';

import { Chunk } from '../../model/DocumentChunk';
import { t } from '../../model/Translation';

interface Step2PreviewProps {
    selectedFiles: File[];
    chunks: Chunk[];
    totalChunks: number;
    selectedFileIndex: number;
    onFileIndexChange: (index: number) => void;
    onPrev: () => void;
    onNext: () => void;
}

@observer
export class Step2Preview extends Component<Step2PreviewProps> {
    renderFileDropdownItem = (file: File, index: number) => (
        <li key={index}>
            <button
                className="dropdown-item"
                onClick={() => this.props.onFileIndexChange(index)}
            >
                {file.name}
            </button>
        </li>
    );

    renderChunk = (chunk: Chunk) => (
        <div key={chunk.id} className="mb-3">
            <div className="d-flex justify-content-between align-items-center mb-2">
                <span className="text-muted" style={{ fontSize: '14px' }}>
                    <Icon name="hash" style={{ fontSize: '12px' }} /> Chunk-
                    {chunk.id}
                </span>
                <span className="text-muted" style={{ fontSize: '14px' }}>
                    {chunk.characters} characters
                </span>
            </div>
            <div
                className="bg-white border rounded p-3"
                style={{ fontSize: '14px', lineHeight: '1.6' }}
            >
                {chunk.text}
            </div>
        </div>
    );

    render() {
        const {
            selectedFiles,
            chunks,
            totalChunks,
            selectedFileIndex,
            onPrev,
            onNext
        } = this.props;

        const currentFile = selectedFiles[selectedFileIndex] || ({} as File);

        return (
            <div>
                <h3 className="mb-4">{t('preview')}</h3>

                <div className="mb-4">
                    <div className="d-flex align-items-center gap-2">
                        <Icon
                            name="file-earmark-word"
                            style={{ fontSize: '20px', color: '#2b579a' }}
                        />
                        <div className="dropdown">
                            <button
                                className="btn btn-link p-0 text-decoration-none text-dark d-flex align-items-center"
                                type="button"
                                data-bs-toggle="dropdown"
                            >
                                <span className="fw-medium">
                                    {currentFile.name}
                                </span>
                                <Icon name="chevron-down" className="ms-2" />
                            </button>
                            <ul className="dropdown-menu">
                                {selectedFiles.map(this.renderFileDropdownItem)}
                            </ul>
                        </div>
                        <span className="text-muted">
                            {totalChunks} {t('chunks_unit')}
                        </span>
                    </div>
                </div>

                <div
                    className="border rounded p-3 mb-4"
                    style={{
                        maxHeight: '500px',
                        overflowY: 'auto',
                        backgroundColor: '#fafafa'
                    }}
                >
                    {chunks.map(this.renderChunk)}
                </div>

                {/* Navigation buttons */}
                <div className="d-flex justify-content-between mt-4">
                    <Button
                        variant="outline-secondary"
                        style={{ minWidth: '120px' }}
                        onClick={onPrev}
                    >
                        <Icon name="arrow-left" className="me-1" />{' '}
                        {t('previous_step')}
                    </Button>
                    <Button
                        variant="primary"
                        style={{
                            minWidth: '120px',
                            backgroundColor: '#4169E1',
                            borderColor: '#4169E1'
                        }}
                        onClick={onNext}
                    >
                        {t('next_step')}{' '}
                        <Icon name="arrow-right" className="ms-1" />
                    </Button>
                </div>
            </div>
        );
    }
}
